import { AlertCircle } from 'lucide-react'

import { de } from '../i18n/de'
import type { CarrierConfidence } from '../api/types'
import { carrierSwatch } from '../lib/status'

export function CarrierBadge({
  code,
  name,
  confidence,
}: {
  code: string
  name: string
  confidence?: CarrierConfidence
}) {
  const uncertain = confidence === 'guessed'
  return (
    <span className="inline-flex shrink-0 items-center gap-1">
      <span className="inline-flex items-center gap-1.5 text-xs font-medium text-slate-700 dark:text-slate-300">
        <span className={`h-2 w-2 shrink-0 rounded-sm ${carrierSwatch(code)}`} aria-hidden />
        {name}
      </span>
      {/* A guessed carrier is flagged rather than silently presented as fact. */}
      {uncertain && (
        <span title={de.confidence.guessed} className="text-amber-600 dark:text-amber-400">
          <AlertCircle className="h-3.5 w-3.5" aria-label={de.confidence.guessed} />
        </span>
      )}
    </span>
  )
}
